import getApiClient from 'react/services/api_client';
import GetNotificationsQuery from './graphql/get_notifications.graphql';
import GetNotificationTopics from './graphql/get_notification_topics.graphql';
import MarkAsSeenNotification from './graphql/mark_as_seen_notification.graphql';
import MarkAsSeenAllNotification from './graphql/mark_as_seen_all_notification.graphql';
import get from 'lodash/get';

const getNotifications = ({ only_unseen, ids, first, topic_key }) => {
  const apiClient = getApiClient();

  return apiClient
    .query({
      query: GetNotificationsQuery,
      variables: {
        ids,
        only_unseen,
        first,
        topic_key,
        includeSummary: true,
      },
      fetchPolicy: 'network-only',
    })
    .then( (result) => {
      const notifications = get(result, 'data.notifications.nodes');
      const notifications_summary = get(result, 'data.notifications_summary');
      return { notifications, notifications_summary };
    });
}

const getNotificationsTopics = () => {
  const apiClient = getApiClient();

  return apiClient
    .query({
      query: GetNotificationTopics
    })
    .then( (result) => {
      const notifications = get(result, 'data.notification_topics');
      return notifications;
    });
}

const markAsSeen = (id) => {
  const apiClient = getApiClient();

  return apiClient
    .mutate({
      mutation: MarkAsSeenNotification,
      variables: {
        input: {
          id,
        },
      },
    })
    .then( (result) => {
      const notification = get(result, 'data.mark_as_seen_notification.notification');
      return notification;
    });
}

const markAllAsSeen = () => {
  const apiClient = getApiClient();

  return apiClient
    .mutate({
      mutation: MarkAsSeenAllNotification,
      variables: {
        input: {},
      },
    })
    .then( (result) => {
      const qty = get(result, 'data.mark_as_seen_all_notification.qty');
      return qty;
    });
}

export { getNotifications, getNotificationsTopics, markAsSeen, markAllAsSeen };